import { fetchFirebaseTokenGraphQL } from './fetchFirebaseToken';

export const TOKEN_STORAGE_KEYS = 'auth_token_storage';

export interface IFirebaseTokenService {
    refreshToken: () => Promise<void>;
    getToken: () => string;
    saveToken: (token: string, expireAt: number) => void;
}

class FirebaseTokenService {
    static #instance: FirebaseTokenService | null = null;
    #token = '';
    #expireAt = 0;

    private constructor(token: string, expireAt: number) {
        this.saveToken(token, expireAt);
    }

    static getInstance(token: string, expireAt: number): FirebaseTokenService {
        if (!FirebaseTokenService.#instance) {
            FirebaseTokenService.#instance = new FirebaseTokenService(token, expireAt);
        } else if (token && token !== FirebaseTokenService.#instance.#token) {
            FirebaseTokenService.#instance.saveToken(token, expireAt);
        }

        return FirebaseTokenService.#instance;
    }

    shouldRefreshToken(): boolean {
        return !this.#token || Date.now() >= this.#expireAt * 1000;
    }

    async refreshToken(): Promise<void> {
        const firebaseToken = await fetchFirebaseTokenGraphQL();

        this.saveToken(firebaseToken.jwt, firebaseToken.expireAt);
    }

    getToken(): string {
        return this.#token;
    }

    getExpireAt(): number {
        return this.#expireAt;
    }

    saveToken(token: string, expireAt: number): void {
        this.#token = token;
        this.#expireAt = expireAt;
    }
}

export default FirebaseTokenService;
